<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1 class="mobile-title">Chi tiết trạng thái sử dụng thiết bị</h1>
      <div class="float-right group-button mobile-buttons">
        <button
          type="button"
          class="btn btn-primary font-medium m-r-10 mobile-btn"
          @click="$refs.changeStoreRef.show(infoData)"
        >
          <b-icon icon="arrow-repeat" aria-hidden="true" />
          <span class="btn-text">Thay đổi cửa hàng</span>
        </button>
        <button
          type="button"
          class="font-medium f12 btn btn-outline-secondary m-r-10 mobile-btn"
          @click="$router.push('/customer-support/device-store')"
        >
          <b-icon icon="arrow-left" aria-hidden="true" />
          <span class="btn-text">Quay lại</span>
        </button>
      </div>
      <hr />
    </div>
    <div class="p-10 card pt-15 mobile-card">
      <div class="card-header m-b-10"></div>
      <!-- Hiển thị dữ liệu -->
      <b-row>
        <b-col cols="12" md="6" class="mobile-col">
          <DetailInfo
            title="Thông tin chung"
            :info="infoData"
            :isLoading="isLoading"
            :fields="keyNameInfo"
          >
            <template #contractCreatAt="{ value }">
              <span>
                {{ value | formatDate('HH:mm, DD/MM/YYYY') }}
              </span>
            </template>
          </DetailInfo>
        </b-col>
        <b-col cols="12" md="6" class="mobile-col">
          <DetailInfo
            title="Thông tin merchant"
            :info="infoData"
            :isLoading="isLoading"
            :fields="keyNameMc"
          >
            <template #accountName="{ value }">
              <div class="mobile-link-info">
                <b-link target="_blank" :href="`/customer-support/account/${infoData?.mcAccId}`">{{
                  value
                }}</b-link>
                <p>{{ infoData?.email }}</p>
              </div>
            </template>
            <template #storeName="{ value }">
              <div class="mobile-link-info">
                <b-link target="_blank" :href="`/customer-support/store/${infoData?.storeId}`">{{
                  value
                }}</b-link>
                <p>{{ infoData?.email }}</p>
                <p><i class="bx bxs-map"></i> {{ infoData?.address }}</p>
              </div>
            </template>
          </DetailInfo>
        </b-col>
        <b-col cols="12" md="12">
          <div class="form-detail">
            <h1 style="border-bottom: none" class="mobile-section-title">
              <strong class="h1-strong">Lịch sử điều chuyển thiết bị</strong>
            </h1>

            <!-- Desktop Table -->
            <div class="desktop-table d-none d-md-block">
              <b-table
                :busy.sync="isLoading"
                head-variant="light"
                sticky-header
                hover
                responsive
                :items="listDevice"
                :fields="fieldsTableHistory"
                selectable
                show-empty
                select-mode="single"
                :fixed="true"
                :bordered="true"
              >
                <template #table-busy>
                  <div class="text-center my-2">
                    <b-spinner class="align-middle" />
                  </div>
                </template>
                <template #cell(user)="{ item }">
                  <div>
                    <p>{{ item?.createByName }}</p>
                    <b-link :href="`mailto:${item?.createByEmail}`">{{
                      item?.createByEmail
                    }}</b-link>
                  </div>
                </template>
                <template #cell(reason)="{ item }">
                  <span>{{ getReason(item?.reason) }}</span>
                </template>
                <template #cell(ownerStatus)="{ item }">
                  <span>{{ getStatusName(item?.ownerStatus) }}</span>
                </template>
                <template #cell(code)="{ item }">
                  <a :href="`/customer-support/order-contract/${item?.id}`" target="_blank">
                    {{ item?.code }}</a
                  >
                </template>
                <template #cell(sender)="{ item }">
                  <p>{{ item?.sender?.name }}</p>
                  <p>{{ item?.sender?.email }}</p>
                </template>
                <template #cell(receiver)="{ item }">
                  <p>{{ item?.receiver?.name }}</p>
                  <p>{{ item?.receiver?.email }}</p>
                </template>
                <template #cell(status)="{ item }">
                  <span :class="`badge ${getStatusObj(item?.status)?.bgColor}`">
                    {{ getStatusObj(item?.status)?.text }}
                  </span>
                </template>
                <template #cell(ownerType)="{ item }">
                  <span>
                    {{ getOwnershipType(item?.ownerType) }}
                  </span>
                </template>
                <template #empty>
                  <div class="text-center text-info my-2">Không có dữ liệu</div>
                </template>
              </b-table>
            </div>

            <!-- Mobile Cards -->
            <div class="mobile-cards d-block d-md-none">
              <div v-if="isLoading" class="text-center my-3">
                <b-spinner class="align-middle" />
              </div>
              <div v-else-if="listDevice.length === 0" class="text-center text-info my-3">
                Không có dữ liệu
              </div>
              <div v-else>
                <div v-for="(item, index) in listDevice" :key="index" class="mobile-history-card">
                  <div class="card-row">
                    <span class="label">Thời gian:</span>
                    <span class="value">{{
                      item.dateCreateContract | formatDate('HH:mm, DD/MM/YYYY')
                    }}</span>
                  </div>
                  <div class="card-row">
                    <span class="label">Người thực hiện:</span>
                    <div class="value">
                      <p>{{ item?.createByName }}</p>
                      <b-link :href="`mailto:${item?.createByEmail}`">{{
                        item?.createByEmail
                      }}</b-link>
                    </div>
                  </div>
                  <div class="card-row">
                    <span class="label">Mã phiếu:</span>
                    <a
                      class="value"
                      :href="`/customer-support/order-contract/${item?.id}`"
                      target="_blank"
                    >
                      {{ item?.code }}
                    </a>
                  </div>
                  <div class="card-row">
                    <span class="label">Đối tượng chuyển:</span>
                    <div class="value">
                      <p>{{ item?.sender?.name }}</p>
                      <p>{{ item?.sender?.email }}</p>
                    </div>
                  </div>
                  <div class="card-row">
                    <span class="label">Đối tượng nhận:</span>
                    <div class="value">
                      <p>{{ item?.receiver?.name }}</p>
                      <p>{{ item?.receiver?.email }}</p>
                    </div>
                  </div>
                  <div class="card-row">
                    <span class="label">Trạng thái phiếu:</span>
                    <span :class="`badge ${getStatusObj(item?.status)?.bgColor} value`">
                      {{ getStatusObj(item?.status)?.text }}
                    </span>
                  </div>
                  <div class="card-row">
                    <span class="label">Trạng thái sở hữu:</span>
                    <span class="value">{{ getStatusName(item?.ownerStatus) }}</span>
                  </div>
                  <div class="card-row">
                    <span class="label">Hình thức sở hữu:</span>
                    <span class="value">{{ getOwnershipType(item?.ownerType) }}</span>
                  </div>
                  <div class="card-row">
                    <span class="label">Lý do:</span>
                    <span class="value">{{ getReason(item?.reason) }}</span>
                  </div>
                  <div class="card-row" v-if="item.content">
                    <span class="label">Nội dung:</span>
                    <span class="value">{{ item.content }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>

    <ChangeStoreDevice ref="changeStoreRef" @store-changed="loadData" />
  </div>
</template>

<script>
  import { showMess } from '@/config/utils'
  import DetailInfo from '@/components/cskh/DetailInfo'
  import Config from '@/thirdParty/config'
  import ChangeStoreDevice from './ChangeStoreDevice.vue'

  import { DeviceDetails } from '@/services/customer-support/device-store'
  import moment from 'moment'

  const fieldsTableHistory = [
    {
      key: 'dateCreateContract',
      label: 'Thời gian',
      thStyle: 'min-width: 150px',
      formatter: value => {
        return moment(value).format('HH:mm, DD/MM/YYYY')
      },
    },
    {
      key: 'user',
      label: 'Người thực hiện',
      thStyle: 'min-width: 150px',
    },
    {
      key: 'code',
      label: 'Mã phiếu',
      thStyle: 'min-width: 150px',
    },
    {
      key: 'sender',
      label: 'Đối tượng chuyển',
      thStyle: 'min-width: 150px',
    },
    {
      key: 'receiver',
      label: 'Đối tượng nhận',
      thStyle: 'min-width: 150px',
    },
    {
      key: 'status',
      label: 'Trạng thái phiếu',
      thStyle: 'min-width: 150px',
    },

    {
      key: 'ownerStatus',
      label: 'Trạng thái sở hữu ',
      thStyle: 'min-width: 150px',
    },
    {
      key: 'ownerType',
      label: 'Hình thức sở hữu ',
      thStyle: 'min-width: 150px',
    },
    {
      key: 'reason',
      label: 'Lý do',
      thStyle: 'min-width: 150px',
    },
    {
      key: 'content',
      label: ' Nội dung',
      thStyle: 'min-width: 150px',
    },
  ]

  const typeMapping = {
    EMPLOYEE: 'Nhân viên',
    MERCHANT: 'Merchant',
  }

  export default {
    components: { DetailInfo, ChangeStoreDevice },
    data() {
      return {
        // lấy config
        Config,
        typeMapping,
        fieldsTableHistory,

        // thông tin view detail
        infoData: {},
        listDevice: [],
        totalCount: 0,

        // loading
        isLoading: false,

        // trạng thái
        listStatus: [
          { id: 'NEW', text: 'Tạo mới', bgColor: 'badge-primary' },
          { id: 'COMPLETED', text: 'Hoàn thành', bgColor: 'badge-success' },
          { id: 'CANCEL', text: 'Từ chối', bgColor: 'badge-danger' },
        ],
        keyNameMc: [
          { key: 'ownerName', label: 'Thông tin MO' },
          { key: 'accountName', label: ' Thông tin MA' },
          { key: 'storeName', label: ' Thông tin cửa hàng' },
        ],
        typeOwner: [
          { id: 'PURCHASE', text: 'Mua' },
          { id: 'RENT', text: 'Thuê' },
          { id: 'LEND', text: 'Mượn' },
          { id: 'CASHBACK', text: 'Cashback' },
        ],
        // key detail
        keyNameInfo: [
          { key: 'serialDevice', label: 'Số serial' },
          { key: 'mobileUserStr', label: 'Mobile User' },
          { key: 'categoryName', label: 'Tên thiết bị' },
          { key: 'businessRegistrationNumber', label: 'Mã hợp đồng/ phụ lục' },
          { key: 'contractCreatAt', label: 'Thời gian tạo phụ lục' },
          { key: 'contractCreateName', label: 'Nhân viên tạo phụ lục' },
          { key: 'staffName', label: 'Nhân viên chăm sóc chính ' },
        ],
        statusOwner: [
          { id: 'NEW', text: 'Mới' },
          { id: 'TRANSFERRED', text: 'Chuyển nhượng' },
          { id: 'HANDED_OVER', text: 'Bàn giao' },
          { id: 'LIQUIDATED', text: 'Thanh lý' },
          { id: 'RECALLED', text: 'Thu hồi' },
        ],
      }
    },

    computed: {
      deviceId() {
        return this.$route.params.id
      },
      getReason() {
        return reason => {
          if (!reason) return ''
          const mapReason = Config.listReasonAppendix.reduce((acc, cur) => {
            acc[cur.id] = cur.text
            return acc
          }, {})
          return mapReason[reason] || reason
        }
      },
      getStatusObj() {
        return status => {
          if (!status) return ''
          const mapStatus = this.listStatus.reduce((acc, cur) => {
            acc[cur.id] = cur
            return acc
          }, {})
          return mapStatus[status] || status
        }
      },
      getStatusName() {
        return status => {
          if (!status) return ''
          const mapStatus = this.statusOwner.reduce((acc, cur) => {
            acc[cur.id] = cur.text
            return acc
          }, {})
          return mapStatus[status] || status
        }
      },
      getOwnershipType() {
        return type => {
          if (!type) return ''
          const map = this.typeOwner.reduce((acc, cur) => {
            if (cur && cur.id) {
              acc[cur.id] = cur
            }
            return acc
          }, {})

          return map[type]?.text || type || ''
        }
      },

      getSenderTypeText() {
        return type => {
          return typeMapping[type] || type
        }
      },
    },
    methods: {
      async loadData() {
        try {
          this.isLoading = true
          const res = await DeviceDetails({ id: this.deviceId })
          this.infoData = res.data || {}
          this.listDevice = res.data?.listOderContract || []
        } catch (e) {
          showMess(this, 'Error', e.message, 'danger', 'b-toaster-top-right', 5 * 60 * 60)
        } finally {
          this.isLoading = false
        }
      },
    },
    created() {
      if (this.deviceId) {
        this.loadData()
      }
    },
  }
</script>

<style lang="scss" scoped>
  h1 {
    border-bottom: none;
  }

  .h1-strong {
    border-left: 3px solid #13569f !important;
    padding-left: 5px;
    font-size: larger;
  }

  .spinner-center {
    display: flex;
    justify-content: center;
  }

  .border-row {
    border-bottom: 2px dashed #edf1fa;
    display: flex;
  }

  .btn-class {
    background-color: #edf6ff;
  }

  .btn-class:hover {
    background-color: #007bff;
  }

  .history {
    .b-table-sticky-header {
      min-height: 32.5vh;
      max-height: 32vh;
    }
  }

  /* Mobile Responsive Styles */
  @media (max-width: 767px) {
    .mobile-title {
      font-size: 1.5rem !important;
      margin-bottom: 1rem;
    }

    .mobile-buttons {
      float: none !important;
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
      margin-top: 1rem;
    }

    .group-button {
      width: 100%;
    }

    .mobile-btn {
      width: 100%;
      justify-content: center;
      margin-right: 0 !important;
      margin-bottom: 0.5rem;
    }

    .btn-text {
      margin-left: 0.5rem;
    }

    .mobile-card {
      padding: 0.75rem !important;
    }

    .mobile-col {
      margin-bottom: 1.5rem;
    }

    .mobile-section-title {
      font-size: 1.25rem !important;
      margin-bottom: 1rem;
    }

    .mobile-link-info {
      p {
        margin-bottom: 0.25rem;
        word-break: break-all;
      }
    }
  }

  /* Mobile Cards Styles */
  .mobile-cards {
    .mobile-history-card {
      border: 1px solid #dee2e6;
      border-radius: 0.375rem;
      padding: 1rem;
      margin-bottom: 1rem;
      background-color: #fff;
      box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);

      .card-row {
        display: flex;
        margin-bottom: 0.75rem;
        align-items: flex-start;

        &:last-child {
          margin-bottom: 0;
        }

        .label {
          font-weight: 600;
          color: #495057;
          min-width: 120px;
          margin-right: 0.75rem;
          flex-shrink: 0;
          font-size: 0.875rem;
        }

        .value {
          flex: 1;
          color: #212529;
          word-break: break-word;
          font-size: 0.875rem;

          p {
            margin-bottom: 0.25rem;
          }

          a {
            color: #007bff;
            text-decoration: none;

            &:hover {
              text-decoration: underline;
            }
          }

          &.badge {
            padding: 0.25rem 0.5rem;
            border-radius: 0.25rem;
            color: #fff;
            font-size: 0.75rem;
            font-weight: 500;
          }
        }
      }
    }
  }

  /* Badge Colors */
  .badge-primary {
    background-color: #007bff;
  }

  .badge-success {
    background-color: #28a745;
  }

  .badge-danger {
    background-color: #dc3545;
  }

  /* Responsive adjustments for very small screens */
  @media (max-width: 480px) {
    .mobile-history-card .card-row {
      flex-direction: column;

      .label {
        min-width: auto;
        margin-right: 0;
        margin-bottom: 0.25rem;
      }
    }

    .mobile-title {
      font-size: 1.25rem !important;
    }

    .mobile-section-title {
      font-size: 1.1rem !important;
    }
  }
</style>
